import { useGate } from 'statsig-react';

export const useIsGovDemo = (email: string) => {
  const govDemoGateOn = useGate('gov_demo').value;
  if (email && email.endsWith('@chainalysis.com')) {
    return true;
  }
  const quebecDemoViewingAs = localStorage.getItem('quebec_demo_viewing_as');
  const spainDemoViewingAs = localStorage.getItem('spain_demo_viewing_as');
  const govDemoViewingAs = localStorage.getItem('gov_demo_viewing_as');
  return (
    quebecDemoViewingAs ||
    spainDemoViewingAs ||
    govDemoViewingAs ||
    govDemoGateOn
  );
};
